import { translate } from "../../../utilities/localization";
import { createFormatter } from 'keyboard-i18n';

export const LINE_ITEM_DEFAULT_WIDTH = 120;
export const LINE_ITEM_FIELD_DEFAULT_WIDTHS = {
    DESCRIPTION: 500,
    SUPPLIER_ITEM_NUMBER: 150,
};

// Function that generates constants with fresh translations
const generateConstants = () => {
    const formatter = createFormatter('mod+');
    let formattedMod = formatter()[0];
    if (formattedMod === 'Command') {
        formattedMod = '⌘';
    }

    return {
        DEFAULT_CURRENCY: 'USD',
        DEFAULT_CURRENCY_DECIMAL_PLACES: 2,
        ORDER_FIELDS_KEYS: [
            {
                name: 'PURCHASE_ORDER_NUMBER',
                key: 'purchaseOrderNumber',
                defaultSequence: 1,
                displayName: translate(`orderReviewsDetail.orderForm.details.purchaseOrderNumber.label`),
            },
            {
                name: 'BUYER_COMPANY_ID',
                key: 'buyerCompanyId',
                defaultSequence: 2,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerCompanyId.label`),
            },
            {
                name: 'BUYER_COMPANY_NAME',
                key: 'buyerCompanyName',
                defaultSequence: 2,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerCompanyName.label`),
            },
            {
                name: 'ORDER_DATE',
                key: 'orderDate',
                defaultSequence: 3,
                displayName: translate(`orderReviewsDetail.orderForm.details.orderDate.label`),
            },
            {
                name: 'ORDER_CURRENCY',
                key: 'orderCurrency',
                defaultSequence: 4,
                displayName: translate(`orderReviewsDetail.orderForm.details.orderCurrency.label`),
            },
            {
                name: 'QUOTE_NUMBER',
                key: 'quoteNumber',
                defaultSequence: 5,
                displayName: translate(`orderReviewsDetail.orderForm.details.quoteNumber.label`),
            },
            {
                name: 'SUPPLIER_REPRESENTATIVE_NAME',
                key: 'supplierRepresentativeName',
                defaultSequence: 6,
                displayName: translate(`orderReviewsDetail.orderForm.details.supplierRepresentativeName.label`),
            },
            {
                name: 'REQUESTED_SHIP_DATE',
                key: 'requestedShipDate',
                defaultSequence: 7,
                displayName: translate(`orderReviewsDetail.orderForm.details.requestedShipDate.label`),
            },
            {
                name: 'FREIGHT_TERMS',
                key: 'freightTerms',
                defaultSequence: 8,
                displayName: translate(`orderReviewsDetail.orderForm.details.freightTerms.label`),
            },
            {
                name: 'FREIGHT_ACCOUNT_NUMBER',
                key: 'freightAccountNumber',
                defaultSequence: 9,
                displayName: translate(`orderReviewsDetail.orderForm.details.freightAccountNumber.label`),
            },
            {
                name: 'BILLING_TERMS',
                key: 'billingTerms',
                defaultSequence: 10,
                displayName: translate(`orderReviewsDetail.orderForm.details.billingTerms.label`),
            },
            {
                name: 'BUYER_CONTACT_INFORMATION',
                key: 'buyerContactInformation',
                defaultSequence: 11,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerContactInformation.label`),
            },
            {
                name: 'SPECIAL_INSTRUCTIONS',
                key: 'specialInstructions',
                defaultSequence: 12,
                displayName: translate(`orderReviewsDetail.orderForm.details.specialInstructions.label`),
            },
            {
                name: 'TOTAL_AMOUNT',
                key: 'totalAmount',
                defaultSequence: 13,
                displayName: translate(`orderReviewsDetail.orderForm.details.totalAmount.label`),
            },
            {
                name: 'SUBTOTAL_AMOUNT',
                key: 'subtotalAmount',
                defaultSequence: 14,
                displayName: translate(`orderReviewsDetail.orderForm.details.subtotalAmount.label`),
            },
            {
                name: 'TOTAL_TAXES',
                key: 'totalTaxes',
                defaultSequence: 15,
                displayName: translate(`orderReviewsDetail.orderForm.details.totalTaxes.label`),
            },
            {
                name: 'TAX_EXEMPT_INFORMATION',
                key: 'taxExemptInformation',
                defaultSequence: 16,
                displayName: translate(`orderReviewsDetail.orderForm.details.taxExemptInformation.label`),
            },
            {
                name: 'TAX_REGISTRATION',
                key: 'taxRegistration',
                defaultSequence: 17,
                displayName: translate(`orderReviewsDetail.orderForm.details.taxRegistration.label`),
            },
            {
                name: 'UDF_1',
                key: 'userDefinedField1',
                defaultSequence: 18,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField1.label`),
            },
            {
                name: 'UDF_2',
                key: 'userDefinedField2',
                defaultSequence: 19,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField2.label`),
            },
            {
                name: 'UDF_3',
                key: 'userDefinedField3',
                defaultSequence: 20,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField3.label`),
            },
            {
                name: 'UDF_4',
                key: 'userDefinedField4',
                defaultSequence: 21,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField4.label`),
            },
            {
                name: 'UDF_5',
                key: 'userDefinedField5',
                defaultSequence: 22,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField5.label`),
            },
            {
                name: 'UDF_6',
                key: 'userDefinedField6',
                defaultSequence: 23,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField6.label`),
            },
            {
                name: 'UDF_7',
                key: 'userDefinedField7',
                defaultSequence: 24,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField7.label`),
            },
            {
                name: 'UDF_8',
                key: 'userDefinedField8',
                defaultSequence: 25,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField8.label`),
            },
            {
                name: 'UDF_9',
                key: 'userDefinedField9',
                defaultSequence: 26,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField9.label`),
            },
            {
                name: 'UDF_10',
                key: 'userDefinedField10',
                defaultSequence: 27,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField10.label`),
            },
            {
                name: 'UDF_11',
                key: 'userDefinedField11',
                defaultSequence: 28,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField11.label`),
            },
            {
                name: 'UDF_12',
                key: 'userDefinedField12',
                defaultSequence: 29,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField12.label`),
            },
            {
                name: 'UDF_13',
                key: 'userDefinedField13',
                defaultSequence: 30,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField13.label`),
            },
            {
                name: 'UDF_14',
                key: 'userDefinedField14',
                defaultSequence: 31,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField14.label`),
            },
            {
                name: 'UDF_15',
                key: 'userDefinedField15',
                defaultSequence: 32,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField15.label`),
            },
            {
                name: 'UDF_16',
                key: 'userDefinedField16',
                defaultSequence: 33,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField16.label`),
            },
            {
                name: 'UDF_17',
                key: 'userDefinedField17',
                defaultSequence: 34,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField17.label`),
            },
            {
                name: 'UDF_18',
                key: 'userDefinedField18',
                defaultSequence: 35,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField18.label`),
            },
            {
                name: 'UDF_19',
                key: 'userDefinedField19',
                defaultSequence: 36,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField19.label`),
            },
            {
                name: 'UDF_20',
                key: 'userDefinedField20',
                defaultSequence: 37,
                displayName: translate(`orderReviewsDetail.orderForm.details.userDefinedField20.label`),
            }
        ],
        ORDER_BUYER_BILL_TO_ADDRESS_FIELD_KEY: "buyerBillToAddress",
        ORDER_BUYER_BILL_TO_ADDRESS_FIELDS_KEYS: [
            {
                name: 'BUYER_BILL_TO_ADDRESS_ADDRESS_LINE_1',
                key: 'addressLine1',
                defaultSequence: 1,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.addressLine1.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.addressLine1.label.full`),
            },
            {
                name: 'BUYER_BILL_TO_ADDRESS_ADDRESS_LINE_2',
                key: 'addressLine2',
                defaultSequence: 2,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.addressLine2.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.addressLine2.label.full`),
            },
            {
                name: 'BUYER_BILL_TO_ADDRESS_ADDRESS_LINE_3',
                key: 'addressLine3',
                defaultSequence: 3,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.addressLine3.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.addressLine3.label.full`),
            },
            {
                name: 'BUYER_BILL_TO_ADDRESS_PHONE',
                key: 'phone',
                defaultSequence: 4,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.phone.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.phone.label.full`),
            },
            {
                name: 'BUYER_BILL_TO_ADDRESS_EMAIL',
                key: 'email',
                defaultSequence: 5,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.email.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.email.label.full`),
            },
            {
                name: 'BUYER_BILL_TO_ADDRESS_CITY',
                key: 'city',
                defaultSequence: 6,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.city.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.city.label.full`),
            },
            {
                name: 'BUYER_BILL_TO_ADDRESS_COUNTRY_CODE',
                key: 'countryCode',
                defaultSequence: 7,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.countryCode.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.countryCode.label.full`),
            },
            {
                name: 'BUYER_BILL_TO_ADDRESS_LOCALITY',
                key: 'locality',
                defaultSequence: 8,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.locality.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.locality.label.full`),
            },
            {
                name: 'BUYER_BILL_TO_ADDRESS_NAME_LINE_1',
                key: 'nameLine1',
                defaultSequence: 9,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.nameLine1.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.nameLine1.label.full`),
            },
            {
                name: 'BUYER_BILL_TO_ADDRESS_NAME_LINE_2',
                key: 'nameLine2',
                defaultSequence: 10,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.nameLine2.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.nameLine2.label.full`),
            },
            {
                name: 'BUYER_BILL_TO_ADDRESS_POSTAL_CODE',
                key: 'postalCode',
                defaultSequence: 11,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.postalCode.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.postalCode.label.full`),
            },
            {
                name: 'BUYER_BILL_TO_ADDRESS_REGION',
                key: 'region',
                defaultSequence: 12,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.region.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerBillToAddress.region.label.full`),
            },
        ],
        ORDER_BUYER_SHIP_TO_ADDRESS_FIELD_KEY: "buyerShipToAddress",
        ORDER_BUYER_SHIP_TO_ADDRESS_FIELDS_KEYS: [
            {
                name: 'BUYER_SHIP_TO_ADDRESS_ADDRESS_LINE_1',
                key: 'addressLine1',
                defaultSequence: 1,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.addressLine1.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.addressLine1.label.full`),
            },
            {
                name: 'BUYER_SHIP_TO_ADDRESS_ADDRESS_LINE_2',
                key: 'addressLine2',
                defaultSequence: 2,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.addressLine2.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.addressLine2.label.full`),
            },
            {
                name: 'BUYER_SHIP_TO_ADDRESS_ADDRESS_LINE_3',
                key: 'addressLine3',
                defaultSequence: 3,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.addressLine3.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.addressLine3.label.full`),
            },
            {
                name: 'BUYER_SHIP_TO_ADDRESS_PHONE',
                key: 'phone',
                defaultSequence: 4,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.phone.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.phone.label.full`),
            },
            {
                name: 'BUYER_SHIP_TO_ADDRESS_EMAIL',
                key: 'email',
                defaultSequence: 5,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.email.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.email.label.full`),
            },
            {
                name: 'BUYER_SHIP_TO_ADDRESS_CITY',
                key: 'city',
                defaultSequence: 6,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.city.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.city.label.full`),
            },
            {
                name: 'BUYER_SHIP_TO_ADDRESS_COUNTRY_CODE',
                key: 'countryCode',
                defaultSequence: 7,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.countryCode.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.countryCode.label.full`),
            },
            {
                name: 'BUYER_SHIP_TO_ADDRESS_LOCALITY',
                key: 'locality',
                defaultSequence: 8,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.locality.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.locality.label.full`),
            },
            {
                name: 'BUYER_SHIP_TO_ADDRESS_NAME_LINE_1',
                key: 'nameLine1',
                defaultSequence: 9,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.nameLine1.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.nameLine1.label.full`),
            },
            {
                name: 'BUYER_SHIP_TO_ADDRESS_NAME_LINE_2',
                key: 'nameLine2',
                defaultSequence: 10,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.nameLine2.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.nameLine2.label.full`),
            },
            {
                name: 'BUYER_SHIP_TO_ADDRESS_POSTAL_CODE',
                key: 'postalCode',
                defaultSequence: 11,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.postalCode.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.postalCode.label.full`),
            },
            {
                name: 'BUYER_SHIP_TO_ADDRESS_REGION',
                key: 'region',
                defaultSequence: 12,
                displayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.region.label`),
                fullDisplayName: translate(`orderReviewsDetail.orderForm.details.buyerShipToAddress.region.label.full`),
            },
        ],
        ORDER_LINE_ITEM_FIELDS_KEYS: [
            {
                name: 'LINE_NUMBER',
                key: 'lineNumber',
                defaultSequence: 1,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.lineNumber.label`),
            },
            {
                name: 'DESCRIPTION',
                key: 'description',
                defaultSequence: 2,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.description.label`),
            },
            {
                name: 'BUYER_ITEM_NUMBER',
                key: 'buyerItemNumber',
                defaultSequence: 3,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.buyerItemNumber.label`),
            },
            {
                name: 'SUPPLIER_ITEM_NUMBER',
                key: 'supplierItemNumber',
                defaultSequence: 4,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.supplierItemNumber.label`),
            },
            {
                name: 'QUANTITY',
                key: 'quantity',
                defaultSequence: 5,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.quantity.label`),
            },
            {
                name: 'UNIT_OF_MEASURE',
                key: 'unitOfMeasure',
                defaultSequence: 6,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.unitOfMeasure.label`),
            },
            {
                name: 'PRICE_UNIT_OF_MEASURE',
                key: 'priceUnitOfMeasure',
                defaultSequence: 7,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.priceUnitOfMeasure.label`),
            },
            {
                name: 'PRICE_PER_UNIT',
                key: 'pricePerUnit',
                defaultSequence: 8,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.pricePerUnit.label`),
            },
            {
                name: 'EXTENDED_PRICE',
                key: 'extendedPrice',
                defaultSequence: 9,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.extendedPrice.label`),
            },
            {
                name: 'TAXABLE',
                key: 'taxable',
                defaultSequence: 10,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.taxable.label`),
            },
            {
                name: 'CONTACT_NUMBER',
                key: 'contactNumber',
                defaultSequence: 11,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.contactNumber.label`),
            },
            {
                name: 'SUPPLIER_DESCRIPTION',
                key: 'supplierDescription',
                defaultSequence: 12,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.supplierDescription.label`),
            },
            {
                name: 'UDF_1',
                key: 'userDefinedField1',
                defaultSequence: 13,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField1.label`),
            },
            {
                name: 'UDF_2',
                key: 'userDefinedField2',
                defaultSequence: 14,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField2.label`),
            },
            {
                name: 'UDF_3',
                key: 'userDefinedField3',
                defaultSequence: 15,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField3.label`),
            },
            {
                name: 'UDF_4',
                key: 'userDefinedField4',
                defaultSequence: 16,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField4.label`),
            },
            {
                name: 'UDF_5',
                key: 'userDefinedField5',
                defaultSequence: 17,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField5.label`),
            },
            {
                name: 'UDF_6',
                key: 'userDefinedField6',
                defaultSequence: 18,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField6.label`),
            },
            {
                name: 'UDF_7',
                key: 'userDefinedField7',
                defaultSequence: 19,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField7.label`),
            },
            {
                name: 'UDF_8',
                key: 'userDefinedField8',
                defaultSequence: 20,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField8.label`),
            },
            {
                name: 'UDF_9',
                key: 'userDefinedField9',
                defaultSequence: 21,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField9.label`),
            },
            {
                name: 'UDF_10',
                key: 'userDefinedField10',
                defaultSequence: 22,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField10.label`),
            },
            {
                name: 'UDF_11',
                key: 'userDefinedField11',
                defaultSequence: 23,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField11.label`),
            },
            {
                name: 'UDF_12',
                key: 'userDefinedField12',
                defaultSequence: 24,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField12.label`),
            },
            {
                name: 'UDF_13',
                key: 'userDefinedField13',
                defaultSequence: 25,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField13.label`),
            },
            {
                name: 'UDF_14',
                key: 'userDefinedField14',
                defaultSequence: 26,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField14.label`),
            },
            {
                name: 'UDF_15',
                key: 'userDefinedField15',
                defaultSequence: 27,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField15.label`),
            },
            {
                name: 'UDF_16',
                key: 'userDefinedField16',
                defaultSequence: 28,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField16.label`),
            },
            {
                name: 'UDF_17',
                key: 'userDefinedField17',
                defaultSequence: 29,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField17.label`),
            },
            {
                name: 'UDF_18',
                key: 'userDefinedField18',
                defaultSequence: 30,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField18.label`),
            },
            {
                name: 'UDF_19',
                key: 'userDefinedField19',
                defaultSequence: 31,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField19.label`),
            },
            {
                name: 'UDF_20',
                key: 'userDefinedField20',
                defaultSequence: 32,
                displayName: translate(`orderReviewsDetail.orderForm.details.lineItem.userDefinedField20.label`),
            }
        ],
        COMMANDS_LIST: [
            { id:1, key:'zoomIn', label: translate('orderReviewsDetail.keyboardActions.shortcut.zoomIn'), shortcut: `${formattedMod} +` },
            { id:2, key:'zoomOut', label: translate('orderReviewsDetail.keyboardActions.shortcut.zoomOut'), shortcut: `${formattedMod} -` },
            { id:3, key:'detailsTab', label: translate('orderReviewsDetail.keyboardActions.shortcut.detailsTab'), shortcut: `${formattedMod} E` },
            { id:4, key:'lineItemsTab', label: translate('orderReviewsDetail.keyboardActions.shortcut.lineItemsTab'), shortcut: `${formattedMod} I` },
            { id:5, key:'notesTab', label: translate('orderReviewsDetail.keyboardActions.shortcut.notesTab'), shortcut: `${formattedMod} O` },
            { id:6, key:'pageUp', label: translate('orderReviewsDetail.keyboardActions.shortcut.pageUp'), shortcut: `${formattedMod} U` },
            { id:7, key:'pageDown', label: translate('orderReviewsDetail.keyboardActions.shortcut.pageDown'), shortcut: `${formattedMod} D` },
            { id:8, key:'save', label: translate('orderReviewsDetail.keyboardActions.shortcut.save'), shortcut: `${formattedMod} S` },
            { id:9, key:'jumpUp', label: translate('orderReviewsDetail.keyboardActions.shortcut.jumpUp'), shortcut: `${formattedMod} J` },
            { id:10, key:'jumpDown', label: translate('orderReviewsDetail.keyboardActions.shortcut.jumpDown'), shortcut: `${formattedMod} P` },
            { id:11, key:'newLineItem', label: translate('orderReviewsDetail.keyboardActions.shortcut.newLineItem'), shortcut: `${formattedMod} L` },
            { id:12, key:'removeLineItem', label: translate('orderReviewsDetail.keyboardActions.shortcut.removeLineItem'), shortcut: `${formattedMod} DEL` },
        ],
    };
};

export default generateConstants;

export const VIEWS = {
    MESSAGE: 'MESSAGE',
    VIOLATIONS: 'VIOLATIONS',
    DOCUMENT: 'DOCUMENT',
    INSIGHTS: 'INSIGHTS',
};
